var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeekendActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58746 0.25H14.4125C15.4125 0.25 16.0125 1.3625 15.45 2.1875L9.24996 11.5V16.5H10.5C11.1875 16.5 11.75 17.0625 11.75 17.75C11.75 18.4375 11.1875 19 10.5 19H5.49996C4.81246 19 4.24996 18.4375 4.24996 17.75C4.24996 17.0625 4.81246 16.5 5.49996 16.5H6.74996V11.5L0.549964 2.1875C-0.0125362 1.3625 0.587464 0.25 1.58746 0.25ZM10.625 5.25L12.375 2.75H3.61246L5.36246 5.25H10.625ZM21.75 0.25H23.625C24.6625 0.25 25.5 1.0875 25.5 2.125C25.5 3.1625 24.6625 4 23.625 4H21.75V15.25C21.75 17.55 19.7 19.35 17.325 18.9375C15.8125 18.675 14.575 17.4375 14.3125 15.925C13.9 13.55 15.7 11.5 18 11.5C18.4375 11.5 18.8625 11.575 19.25 11.7125V2.75C19.25 1.375 20.375 0.25 21.75 0.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekendActivities);
export default __webpack_public_path__ + "static/media/weekend_activities.3c8491569226004dac7e3f63ce917da5.svg";
export { ForwardRef as ReactComponent };